import { JSX } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useHeaderMenuStyles } from './styles/header-menu.styles';
import {
  errorApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export type HeaderMenuOption = {
  icon: () => JSX.Element;
  title: string;
  subtitle?: string;
  to: string;
  external?: boolean;
  tag?: string;
};

type HeaderMenuProps = {
  options: HeaderMenuOption[];
  onOptionClick: (path: string) => void;
};

export const HeaderMenu = ({ options, onOptionClick }: HeaderMenuProps) => {
  const classes = useHeaderMenuStyles();
  const navigate = useNavigate();
  const identityApi = useApi(identityApiRef);
  const errorApi = useApi(errorApiRef);

  return (
    <Box className={classes.container}>
      {options.map((item, idx) => (
        <Button
          key={idx}
          className={classes.button}
          aria-label={item.title}
          startIcon={item.icon()}
          onClick={() => {
            if (item.to === 'SIGN_OUT') {
              identityApi.signOut().catch(err => errorApi.post(err));
            } else if (item.external) {
              window.open(item.to, '_blank', 'noopener,noreferrer');
            } else if (!!item.to) {
              const path = item.to.startsWith('/') ? item.to : `/${item.to}`;
              navigate(path);
            }
            onOptionClick(item.to);
          }}
        >
          <Box className="buttonContent">
            <Typography className="buttonTitle">{item.title}</Typography>
            {item.subtitle && (
              <Typography className="buttonSubtitle">
                {item.subtitle}
              </Typography>
            )}
          </Box>
        </Button>
      ))}
    </Box>
  );
};
